import { Timeline, TimelineProps } from 'antd'

export { Timeline }
export type { TimelineProps }
